import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { IonicModule } from '@ionic/angular';
import { CardComponent } from './card/card.component';
import { HeaderComponent } from './header/header.component';
import { BreadcrumbComponent } from './breadcrumb/breadcrumb.component';
import { RouterModule } from '@angular/router';
import { PopoverComponent } from './popover/popover.component';
import { TermsComponent } from './terms/terms.component';
import { FooterComponent } from './footer/footer.component';



@NgModule({
  declarations: [
    CardComponent,
    HeaderComponent,
    BreadcrumbComponent,
    PopoverComponent,
    TermsComponent,
    FooterComponent
  ],
  imports: [
    CommonModule,
    IonicModule,
    RouterModule
  ],
  exports: [
    CardComponent,
    HeaderComponent,
    BreadcrumbComponent,
    PopoverComponent,
    TermsComponent,
    FooterComponent
  ]
})
export class ComponentsModule { }
